import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";

export class SetAgencyUserDisabledUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    // disabled:true blocks new sign-ins, but an already-issued ID token stays
    // valid until it expires (up to 1h) — no active-token revocation yet.
    async execute(agencyId: string, uid: string, disabled: boolean): Promise<void> {
        return this.agencyRepository.setAgencyUserDisabled(agencyId, uid, disabled)
    }
}
